// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"6bbd0faa4be6a2765738","418":"78be25e2e78c6c82e691","661":"24f6fdc9c0a58710e6c7"}[chunkId] + ".bundle.js";
};